import { render } from "./BatchCosts.vue?vue&type=template&id=0dad457f&scoped=true"
import script from "./BatchCosts.vue?vue&type=script&lang=js"
export * from "./BatchCosts.vue?vue&type=script&lang=js"

import "./BatchCosts.vue?vue&type=style&index=0&id=0dad457f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dad457f"]])

export default __exports__